var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderForm',{attrs:{"order":_vm.order,"formType":_vm.formType,"buttonLoading":_vm.buttonLoading},on:{"saveOrder":_vm.updateOrder}})
}
var staticRenderFns = []

export { render, staticRenderFns }